export const RealtimeEventType = {
  SOCIAL_ACCOUNT_UNLINKED: 'SOCIAL_ACCOUNT_UNLINKED',
  WALLET_CONNECTED: 'WALLET_CONNECTED',
  TRUSTLINE_SUCCESS: 'TRUSTLINE_SUCCESS',
  TRUSTLINE_FAILED: 'TRUSTLINE_FAILED',
  CRYPTO_PAYMENT_SUCCESS: 'CRYPTO_PAYMENT_SUCCESS',
  CRYPTO_PAYMENT_FAILED: 'CRYPTO_PAYMENT_FAILED',
  CARD_PAYMENT_SUCCESS: 'CARD_PAYMENT_SUCCESS',
  CARD_PAYMENT_FAILED: 'CARD_PAYMENT_FAILED',
  POINTS_EARNED: 'POINTS_EARNED',
  POINTS_SPENT: 'POINTS_SPENT',
};
